import { format } from 'date-fns';
import { useCallback, useState } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { HistoryForm, HistoryRecordState, UpdateHistoryDto } from 'types/histories';
import { DEFAULT_DATE_FORMAT } from 'utils/parseDate';
import { HistoryFormData } from './HistoryModal';

interface Props {
    index: number;
    history: HistoryForm;
    setValue: UseFormSetValue<HistoryFormData>;
}

export const useHistoryRecord = ({ index, history, setValue }: Props) => {
    const [recordState, setRecordState] = useState<HistoryRecordState>(history.recordState);

    const updateRecordState = useCallback(() => {
        const newRecordState =
            recordState === HistoryRecordState.VIEWING ? HistoryRecordState.EDITING : HistoryRecordState.VIEWING;

        setValue(`histories.${index}.recordState`, newRecordState);
        setRecordState(newRecordState);
    }, [index, recordState, setValue]);

    const mapToUpdateHistoryDto = useCallback((startDate: string, endDate: string | null): UpdateHistoryDto => {
        return {
            startDate: startDate === null ? null : format(new Date(startDate), DEFAULT_DATE_FORMAT),
            endDate: endDate === null ? null : format(new Date(endDate), DEFAULT_DATE_FORMAT),
        };
    }, []);

    return { recordState, updateRecordState, mapToUpdateHistoryDto };
};
